import { AutogenLayoutMobileCommSendLoadHistory } from "./autogen/AutogenLayoutMobileCommSendLoadHistory";
import { LookupModelSearchEvent, DataSourceExecutionEvent, Textbox } from "@mcleod/components";

export class MobileCommSendLoadHistory extends AutogenLayoutMobileCommSendLoadHistory {
    private readonly RECORD_TYPE_ROUTE = 'R';
    private readonly RECORD_TYPE_STOP = 'S';
    private readonly RECORD_TYPE_LOCATION = 'L';

    /** This is an event handler for the beforeLookupModelSearch event of textboxMcControlId. */
    textboxMcControlIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }

    /** This is an event handler for the afterExecution event of sourceMcZmitHistory. */
    sourceMcZmitHistoryAfterExecution(event: DataSourceExecutionEvent) {
        this.defineLocalTooltip(this.textboxLocalId, event.data.get("record_type"), event.data.get("local_id"));
    }

    private defineLocalTooltip(local_id_textbox: Textbox, record_type: string, local_id: string): void {
        if (record_type === this.RECORD_TYPE_ROUTE) {
            local_id_textbox.quickInfoLayout = 'lme/powerbroker/MovementQuickInfo';
            local_id_textbox.quickInfoOverrideKeyValue = local_id.split('-')[0];
        } else if (record_type === this.RECORD_TYPE_STOP) {
            local_id_textbox.quickInfoLayout = 'lme/dispatch/StopQuickInfo';
            local_id_textbox.quickInfoOverrideKeyValue = local_id;
        } else if (record_type === this.RECORD_TYPE_LOCATION) {
            local_id_textbox.quickInfoLayout = 'lme/dispatch/LocationQuickInfo';
            local_id_textbox.quickInfoOverrideKeyValue = local_id;
        }
    }
}
